import axios from '@/services/api';


export const getTrails = async ({ commit }, params) => {

    const response = await axios.get('/trails', { params: params})

    const { data } = response;

    try {
        if (data) {
            commit('setTrails', data);
        }

    } catch (e) {
        console.log(e);
    }

};

export const getTrailById = async ({ commit }, id) => {
    commit('setCurrentTrail', null);
    const response = await axios.get(`/trails/${id}`)

    const { data } = response;

    try {
        if (data) {
            commit('setCurrentTrail', data);
        }

    } catch (e) {
        console.log(e);
    }
}

export const add = async (_, payload) => {

    return await axios.post("trails", payload)
        .then((response) => response)
        .catch((e) => e.response);
};

export const edit =  async(_, payload) => {

    if (payload instanceof FormData) {
        return await axios.post("trails", payload)
            .then((response) => response)
            .catch((e) => e.response);
    } else {
        return await axios.put("trails/" + payload.id, payload)
            .then((response) => response)
            .catch((e) => e.response);
    }
};

export const deleteTrail = async ( _, id) => {
    const response = await axios.delete(`/trails/${id}`);
    // The shared interceptor resolves HTTP errors instead of rejecting them.
    if (response instanceof Error || response.response) {
        throw response;
    }
    return response;

};
